import { SeoRenderer } from "../../../common/helpers/seo";

import AboutUs from "./loadable"

export default {
    component: AboutUs,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({
            title: allMessage["aboutus.story.h2"],
            description: allMessage["aboutus.story.p"],
            allMessage,
            lang,
        });
    },
};
